import { create, type StoreApi } from 'zustand';
import { devtools } from 'zustand/middleware';
import {
	createDateTimeSlice,
	type DateTimeSlice,
} from './slices/dateTimeSlice';
import { createUISlice, type UISlice } from './slices/uiSlice';
import { createConfigSlice, type ConfigSlice } from './slices/configSlice';
import {
	createServicesSlice,
	type ServicesSlice,
} from './slices/servicesSlice';
import {
	createResourcesSlice,
	type ResourcesSlice,
} from './slices/resourcesSlice';
import {
	createFormFieldsSlice,
	type FormFieldsSlice,
} from './slices/formFieldsSlice';

export type BookingStore = DateTimeSlice &
	UISlice &
	ConfigSlice &
	ServicesSlice &
	ResourcesSlice &
	FormFieldsSlice;

/**
 * Factory function to create a new booking store instance.
 * Each booking field gets its own isolated store.
 *
 * @param uniqueId - The unique ID for devtools naming
 * @return A new Zustand store instance
 */
export function createBookingStore(uniqueId: string): StoreApi<BookingStore> {
	return create<BookingStore>()(
		devtools(
			(...a) => ({
				...createDateTimeSlice(...a),
				...createUISlice(...a),
				...createConfigSlice(...a),
				...createServicesSlice(...a),
				...createResourcesSlice(...a),
				...createFormFieldsSlice(...a),
			}),
			{ name: `BookingStore-${uniqueId}` }
		)
	);
}
